import { render, staticRenderFns } from "./BackgroundMask.vue?vue&type=template&id=98ed347a&functional=true&"
import script from "./BackgroundMask.vue?vue&type=script&lang=js&"
export * from "./BackgroundMask.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundMask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports